import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BCivilCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Civil Engineering",
    shortName: "B.E. Civil",
    duration: "4 years",
    description: "Fundamental engineering discipline focusing on infrastructure design, construction, and environmental systems",
    overview: "Bachelor of Engineering in Civil Engineering (B.E. Civil) is a 4-year undergraduate program that deals with the design, construction, and maintenance of physical and naturally built environments including roads, bridges, buildings, dams, and water supply systems. This course combines engineering principles with environmental considerations to create sustainable infrastructure solutions for society.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Building Materials & Construction",
          "Engineering Mechanics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Fluid Mechanics",
          "Surveying",
          "Engineering Geology",
          "Structural Analysis",
          "Environmental Engineering"
        ]
      },
      {
        year: 3,
        subjects: [
          "Concrete Technology",
          "Soil Mechanics",
          "Transportation Engineering",
          "Water Resources Engineering",
          "Steel Structures",
          "Foundation Engineering"
        ]
      },
      {
        year: 4,
        subjects: [
          "Project Management",
          "Earthquake Engineering",
          "Construction Technology",
          "Estimation & Costing",
          "Capstone Project",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Civil Engineer",
        "Structural Engineer",
        "Construction Manager",
        "Project Manager",
        "Site Engineer",
        "Design Engineer",
        "Highway Engineer",
        "Water Resources Engineer",
        "Environmental Engineer",
        "Quantity Surveyor"
      ],
      industries: [
        "Construction & Infrastructure",
        "Government & Public Works",
        "Consulting Engineering",
        "Real Estate Development",
        "Water & Wastewater Management",
        "Transportation & Highways",
        "Environmental Services",
        "Oil & Gas Infrastructure",
        "Power Generation",
        "Mining & Tunneling"
      ],
      averageSalary: "₹3-10 LPA",
      topRecruiters: [
        "L&T Construction",
        "Tata Projects",
        "Hindustan Construction Company",
        "Gammon India",
        "IRCON International",
        "RITES Ltd",
        "NHPC",
        "NTPC",
        "Public Works Department",
        "Private Consulting Firms"
      ]
    },

    topColleges: [
      {
        name: "Indian Institute of Technology (IIT) Madras",
        location: "Chennai, Tamil Nadu",
        fees: "₹2,50,000/year",
        ranking: "1"
      },
      {
        name: "Indian Institute of Technology (IIT) Delhi",
        location: "New Delhi",
        fees: "₹2,50,000/year",
        ranking: "2"
      },
      {
        name: "National Institute of Technology (NIT) Warangal",
        location: "Telangana",
        fees: "₹1,50,000/year",
        ranking: "3"
      },
      {
        name: "Birla Institute of Technology (BITS) Pilani",
        location: "Rajasthan",
        fees: "₹4,50,000/year",
        ranking: "4"
      },
      {
        name: "Delhi Technological University",
        location: "Delhi",
        fees: "₹1,20,000/year",
        ranking: "5"
      }
    ],

    skills: [
      "AutoCAD & Civil Design Software",
      "Structural Analysis Software (STAAD, ETABS)",
      "Project Management",
      "Construction Planning",
      "Surveying & Mapping",
      "Material Testing",
      "Cost Estimation",
      "Safety Management",
      "Environmental Assessment",
      "Contract Management"
    ],

    futureScope: "Civil Engineering offers stable and growing career opportunities with India's focus on infrastructure development, smart cities, and sustainable construction. Emerging areas include green building technology, smart infrastructure, disaster management, and sustainable urban planning. Graduates can pursue specializations, research, or leadership roles in construction and infrastructure sectors.",

    faqs: [
      {
        question: "What are the main specializations in Civil Engineering?",
        answer: "Major specializations include Structural Engineering, Transportation Engineering, Water Resources, Environmental Engineering, Geotechnical Engineering, and Construction Management."
      },
      {
        question: "Is Civil Engineering a stable career choice?",
        answer: "Yes, Civil Engineering offers stable career prospects due to continuous infrastructure development needs, government projects, and urbanization trends."
      },
      {
        question: "What software knowledge is important for Civil Engineers?",
        answer: "Important software includes AutoCAD, STAAD Pro, ETABS, Primavera, MS Project, GIS software, and BIM tools like Revit."
      },
      {
        question: "Can Civil Engineers work in private companies?",
        answer: "Yes, Civil Engineers work in private construction companies, consulting firms, real estate developers, infrastructure companies, and can also start their own ventures."
      },
      {
        question: "What are the government job opportunities?",
        answer: "Government opportunities include PWD, Railways, CPWD, NHAI, state infrastructure departments, and public sector undertakings like NTPC, NHPC."
      }
    ],

    admissionProcess: [
      "JEE Main Qualification",
      "State CET Examination (for state colleges)",
      "Choice Filling & Counseling",
      "Seat Allotment",
      "Document Verification",
      "Fee Payment & Admission Confirmation"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BCivilCoursePage;
